import React from 'react';

export interface TextItemInfoProps {
    children: any;
}

const TextItemInfo = ({children}: TextItemInfoProps) => {
    return (
        <div className={`text-item__info`}>
            {children}
        </div>
    )
}

export default TextItemInfo;
